export default {
	1366:1170,
	1200:1053,
	1000:971.1,
	768:748.8
}